import MojitoCore from 'mojito/core';
import CountryIconImpl from './country-icon';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;

/**
 * `CountryIcon` is a component used to render a country icon.
 *
 * @class CountryIcon
 * @memberof Mojito.Presentation.Components
 */

/**
 * `CountryIcon` component prop types.
 *
 * @property {string} countryCode - Country code value for search country icon.
 * @property {string} countryName - Country name value for image alt.
 * @property {string} [class] - Additional CSS class name.
 *
 * @memberof Mojito.Presentation.Components.CountryIcon
 */
const propTypes = {
    countryCode: PropTypes.string,
    countryName: PropTypes.string,
    class: PropTypes.string,
};

export default UIView('CountryIcon', CountryIconImpl, propTypes);
